import React from 'react';
import { Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { pluralise } from 'src/libs/utils';

export const useStyles = makeStyles((theme) => ({
    container: {
        position: 'absolute',
        top: '0.5rem',
        left: '-0.5rem',
        backgroundColor: theme.palette.primary.main,
        border: `2px solid ${theme.palette.primary.main}`,
        padding: '0 0.5rem',
    },
    text: {
        textTransform: 'uppercase',
    },
}));

type OfficeCountProps = {
    count: number;
    useWhichAvailablity?: string;
    className?: string;
}

export const OfficeCount = ({ count, useWhichAvailablity, className }: OfficeCountProps) => {
    const classes = useStyles();
    let string = '';
    switch (useWhichAvailablity) {
        case 'let':
            string = 'Let';
            break;
        case 'under offer':
            string = 'Under Offer';
            break;
        case 'coming soon':
            string = 'Coming Soon';
            break;
        default:
            string = `${count} ${pluralise(count, 'office')} available`;
            break;
    }
    return (
        <Box className={`${classes.container} ${className}`}>
            <Typography color="secondary" variant="h6" className={classes.text}>
                {string}
            </Typography>
        </Box>
    );
};
